import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bb944b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tasks-page" }
const _hoisted_2 = { class: "tasks-page__main" }
const _hoisted_3 = { class: "tasks-page__form" }
const _hoisted_4 = {
  key: 0,
  class: "tasks-page__sidebar"
}

import useQuasar from 'quasar/src/composables/use-quasar.js';;

import Form from '@/components/Form.vue';
import TasksContainer from '@/components/tasks/TasksContainer.vue';
import StreaksHomeCard from '@/components/tasks/partials/StreaksHomeCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tasks',
  setup(__props) {

const $q = useQuasar();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Form)
      ]),
      _createVNode(TasksContainer)
    ]),
    (_unref($q).screen.gt.xs)
      ? (_openBlock(), _createElementBlock("aside", _hoisted_4, [
          _createVNode(StreaksHomeCard)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})